import { HStack, MonthRangePicker, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

const MAX_MONTH_RANGE = 12;

export interface PeriodSelection {
  initialDate?: Date;
  finalDate?: Date;
}

export interface PeriodRangeSelectProps {
  forceMobile: boolean;
  selection?: PeriodSelection;
  onSelectionChange: (selection: PeriodSelection) => void;
  hasError: boolean;
  onErrorUpdate: (hasError: boolean) => void;
}

const monthDiffInclusive = (initialDate: Date, finalDate: Date) => {
  const yearsDiff = finalDate.getFullYear() - initialDate.getFullYear();
  const monthsDiff = finalDate.getMonth() - initialDate.getMonth();

  return yearsDiff * 12 + monthsDiff + 1;
};

export const PeriodRangeSelect: React.FC<PeriodRangeSelectProps> = ({
  forceMobile,
  selection,
  onSelectionChange,
  hasError,
  onErrorUpdate,
}) => {
  const handleClearDates = () => {
    onErrorUpdate(false);
    onSelectionChange({ initialDate: undefined, finalDate: undefined });
  };

  const handleSelectDates = (initialDate: Date, finalDate: Date) => {
    const normalizedInitialDate = Utils.Mask.NormalizeToMonthStart(initialDate);
    const normalizedFinalDate = Utils.Mask.NormalizeToMonthStart(finalDate);

    const sortedInitialDate =
      normalizedInitialDate <= normalizedFinalDate ? normalizedInitialDate : normalizedFinalDate;
    const sortedFinalDate =
      normalizedInitialDate <= normalizedFinalDate ? normalizedFinalDate : normalizedInitialDate;

    if (monthDiffInclusive(sortedInitialDate, sortedFinalDate) > MAX_MONTH_RANGE) {
      onErrorUpdate(true);
      return;
    }

    onErrorUpdate(false);
    onSelectionChange({ initialDate: sortedInitialDate, finalDate: sortedFinalDate });
  };

  return (
    <VStack space="inline.xxxs" zIndex={20}>
      <Text variant="semibold">
        Selecione o período
        <Text color="feedback.error.default">*</Text>
      </Text>

      <HStack w="full" space="stack.nano">
        <MonthRangePicker
          initialMonth={selection?.initialDate || undefined}
          finalMonth={selection?.finalDate || undefined}
          onClear={handleClearDates}
          onSelectMonths={handleSelectDates}
          calendarPosition="left"
          placeholder="Selecione o período"
          allowSingleDateAsRange
          forceMobile={forceMobile}
          inputComponentProps={{
            error: hasError ? { message: 'O intervalo máximo permitido é de 12 meses' } : undefined,
          }}
        />
      </HStack>
    </VStack>
  );
};
